module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cultura-color-3c4727bb69cc5d5f7be9e3fe28938710.png";